import { Component } from 'react';
import { compose } from 'redux';
import { debounce } from 'lodash';
import { connectStateResults } from 'react-instantsearch/connectors';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import * as INDEX_KEYS from './constants/indexKeys';

class AlgoliaTracking extends Component {
  constructor(props) {
    super(props);
    this.sendRequest = debounce(this.sendRequest.bind(this), 3000);
  }

  componentDidMount() {
    this.sendRequest();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // If the query has changed, and the query is not blank we will track it.
    if (nextProps.query !== this.props.query && nextProps.query) {
      this.sendRequest();
    }
  }

  getNbHitsForIndex(indexName) {
    return this.props.allSearchResults[this.props.indexes[indexName]].nbHits;
  }

  sendRequest() {
    const tagHits = this.getNbHitsForIndex(INDEX_KEYS.TAGS);
    const lessonPathHits = this.getNbHitsForIndex(INDEX_KEYS.LESSONS_PATHS);
    const sectionElementHits = this.getNbHitsForIndex(
      INDEX_KEYS.SECTIONS_ELEMENTS,
    );
    const matchCount = tagHits + lessonPathHits + sectionElementHits;
    request.post(routes.LEARN_SEARCH_TRACK, {
      search_event: {
        match_count: matchCount,
        query: this.props.query,
        tag_count: tagHits,
        lesson_path_count: lessonPathHits,
        section_element_count: sectionElementHits,
      },
    });
  }

  render() {
    return null;
  }
}

export default compose(connectStateResults)(AlgoliaTracking);
